var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropDownIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#B2DAC5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5998 8H6.39955C6.32666 8.00023 6.2552 8.02037 6.19288 8.05826C6.13056 8.09614 6.07973 8.15033 6.04587 8.215C6.012 8.27968 5.99639 8.35237 6.0007 8.42527C6.00502 8.49817 6.02909 8.56851 6.07035 8.62872L9.67045 13.838C9.81965 14.054 10.1789 14.054 10.3285 13.838L13.9286 8.62872C13.9702 8.56864 13.9947 8.49826 13.9992 8.42524C14.0038 8.35222 13.9883 8.27935 13.9544 8.21454C13.9205 8.14973 13.8695 8.09547 13.807 8.05765C13.7445 8.01982 13.6728 7.99989 13.5998 8Z",
    fill: "#2E8056"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropDownIcon);
export default __webpack_public_path__ + "static/media/dropDownIcon.8382233d7fb74f5a88ebe9f62856d3ff.svg";
export { ForwardRef as ReactComponent };